import React from 'react';
import styled from '@emotion/styled';
import Box from '@ff/ui/Box';
import Text from '@ff/ui/Text';

export interface Props {
  specs?: {
    title?: string;
    subtitle?: string;
  }[]
}

export default function Specs(props: Props) {
  const { specs } = props;

  return (
    <SpecContainer>
      {specs?.map((item) => (
        <SpecItem key={item.title}>
          <SpecTitle>{item.title}</SpecTitle>
          <SpecSubTitle>{item.subtitle}</SpecSubTitle>
        </SpecItem>
      ))}
    </SpecContainer>
  );
}

const SpecContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '890px',
  justifyContent: 'space-around',
  alignItems: 'center',
  gap: '22px',
  padding: '0px 16px 32px 16px',

  [theme.mediaQueries.md]: {
    padding: '36px 16px',
  }
}));

const SpecTitle = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.light,
  fontSize: '22px',
  lineHeight: '30px',
  color: theme.colors.white,
  textAlign: 'center',

  [theme.mediaQueries.md]: {
    fontSize: '28px',
  },
}));

const SpecSubTitle = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.regular,
  fontSize: '12px',
  lineHeight: '24px',
  color: 'rgba(255, 255, 255, 0.75)',
  textAlign: 'center',
}));

const SpecItem = Box;
